import Api from '@/services/Api'
import axios from 'axios'


export default {
  // Método que llama a la url para crear un chat
 getMenus () {
   return Api().get("/menus");
},
  updateMenu (params) {
    return Api().put("/menus",params);
  },
  addMenu (params) {
    return Api().post("/menus",params);
  },
  getMenu (params) {
    return Api().get("/menus/"+params);
  },
  deleteMenu (params) {
    return Api().delete("/menus/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/MenuService.js